import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { FilterModalComponent } from '../../../shared/components/filter-modal/filter-modal.component';
import { ICampaign } from '../../../shared/interfaces/i-campaign';
import { IFilter } from '../../../shared/interfaces/i-filter';
import { FAST_FILTERS } from '../../../shared/utils/filterColors';
import { WebappService } from './../../../shared/services/webapp.service';

@Component({
  selector: 'mobo-home',
  templateUrl: './home.component.html',
  styles: [],
})
export class HomeComponent implements OnInit {
  @ViewChild('filter') filterComponent!: FilterModalComponent;
  public selectedCampaigns?: ICampaign[];
  public deliveryCampaigns?: ICampaign[];
  public filteredCampaigns?: ICampaign[];
  public recentCampaigns?: ICampaign[];
  public baseUrl = environment.baseUrl;

  private _showOnlyDelivery: boolean = false;
  public get showOnlyDelivery(): boolean {
    return this._showOnlyDelivery;
  }
  public set showOnlyDelivery(v: boolean) {
    this._showOnlyDelivery = v;
    if (v) {
      this.deliveryCampaigns = this.filteredCampaigns?.filter(
        (x) => x.IsDelivery
      );
    } else {
      this.sliceIfNoFilter();
    }
  }

  public filters: IFilter[] = [];
  public fastFilters = FAST_FILTERS;

  constructor(
    public webappService: WebappService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.checkCityId();
    this.webappService.campaigns.subscribe((campaigns) => {
      this.getCampaigns(campaigns);
    });
    this.watchCity();
  }

  ngOnDestroy() {
    this.clearFilter();
  }

  getCampaigns(campaigns: ICampaign[]) {
    this.filteredCampaigns = [...campaigns];

    this.deliveryCampaigns = this.filteredCampaigns.filter((x) => x.IsDelivery);
    this.selectedCampaigns = this.filteredCampaigns.filter(
      (x) => !x.IsDelivery
    );

    this.recentCampaigns = this.selectedCampaigns
      .sort((a: ICampaign, b: ICampaign) => {
        return +new Date(b.createdAt) - +new Date(a.createdAt);
      })
      .slice(0, 3);
    this.sliceIfNoFilter();
  }

  sliceIfNoFilter() {
    if (this.filters[0]) return;
    this.deliveryCampaigns = this.deliveryCampaigns?.slice(0, 9);
    this.selectedCampaigns = this.selectedCampaigns?.slice(0, 9);
  }

  seeAll() {
    this.router.navigate(['/cupons']);
  }

  checkCityId() {
    let activeRoute;
    this.activatedRoute.paramMap.subscribe((params) => {
      activeRoute = params.get('cityId');
      if (activeRoute) {
        this.webappService.selectedCity.next(activeRoute);
      }
    });
  }

  watchCity() {
    this.webappService.selectedCity.subscribe(() => {
      this.showOnlyDelivery = false;
      this.addFilters([]);
      if (this.filterComponent) this.filterComponent.resetFilter();
    });
  }

  toggleFastFilter(filter: IFilter) {
    this.filterComponent.addFilters(filter);
    this.searchFilters();
  }

  addFilters(filters: IFilter[]) {
    this.filters = [...filters];
  }

  removeFilter(filter: IFilter) {
    this.filters = [...this.filters.filter((f) => f.id !== filter.id)];
    this.filterComponent.addFilters(filter);
  }

  searchFilters() {
    let categories = this.filters
      .filter((x) => x.type == 'CATEGORY')
      .map((x) => x.id)
      .join(',');
    let moments = this.filters
      .filter((x) => x.type == 'MOMENT')
      .map((x) => x.id)
      .join(',');
    this.webappService.searchCampaigns(categories, moments);
  }

  clearFilter() {
    this.showOnlyDelivery = false;
    this.addFilters([]);
    this.searchFilters();
    this.filterComponent.resetFilter();
  }

  isFilterSelected(filterId: string | undefined) {
    return this.filters.map((x) => x.id).includes(filterId);
  }
}
